module.exports = __webpack_public_path__ + "media/images/laptop-49ce72d991005a4208b43f0ecacca963.jpeg";